import { render, staticRenderFns } from "./RsaScalaBrassEditComponent.vue?vue&type=template&id=73ce137c"
import script from "./RsaScalaBrassEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaBrassEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports